export default __webpack_public_path__ + "87744a56dd4888a2212d678cdf3a4d95.png";